import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(
      to right,
      ${theme.v3.colors.brand.snappyOrange[60]},
      ${theme.v3.colors.accent.pink[60]}
    );
    border-radius: ${theme.v3.border.radius.lg};
    padding: 16px 8px 16px 24px;
    font-family: ${theme.v3.font.family.brand};
    width: 100%;
    box-sizing: border-box;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-wrap: wrap;
      padding: 20px;
      gap: 12px;
    }
  `}
`;

export const LogoPlaceholder = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 141px;
  height: 24px;

  svg {
    flex: none;
    width: 100%;
    height: 100%;
    margin-top: 4px;
  }

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    order: 0;
    width: 110px;
    height: 19px;

    svg {
      width: 110px;
      height: 19px;
    }
  }
`;

export const Separator = styled.div`
  ${({ theme }) => css`
    width: 2px;
    height: 20px;
    background: rgba(255, 255, 255, 0.64);
    border-radius: ${theme.v3.border.radius.xl};
    flex-shrink: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const Tagline = styled.p`
  ${({ theme }) => css`
    flex: 1;
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.spacious};
    color: ${theme.v3.colors.brand.snappyBlue[98]};
    margin: 0;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 2;
      width: 100%;
      flex: unset;
    }
  `}
`;

export const TaglineIcon = styled.span`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    margin-left: 8px;
    margin-bottom: 2px;
    flex-shrink: 0;
    color: ${theme.v3.colors.brand.snappyBlue[98]};

    svg path {
      fill: ${theme.v3.colors.brand.snappyBlue[98]};
    }
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.v3.spacing.quarck};
    flex-shrink: 0;

    button {
      border-color: transparent;
      &:hover {
        border-color: transparent;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 3;
      justify-content: center;
    }
  `}
`;

export const CloseAdapter = styled.div`
  ${({ theme }) => css`
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      padding: 0;
      cursor: pointer;
      color: ${theme.v3.colors.brand.snappyBlue[98]};

      svg {
        width: ${theme.v3.icon.size.sm};
        height: ${theme.v3.icon.size.sm};
        fill: ${theme.v3.colors.brand.snappyBlue[98]};
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 1;
      margin-left: auto;
    }
  `}
`;
